import { Flex } from '@assets/component/UI/Flex/Flex';
import { SideChatMessage } from '@assets/model/SideChatStore';
import { convertMarkdown } from '@assets/utils/Utils';
import { observer } from 'mobx-react';
import FlLogo from '../FlightlineChatLogo.svg';
import * as style from './WaitingMessage.module.less';
import { LoadingAnimation } from '@assets/component/LoadingAnimation/LoadingAnimation';

const WaitingMessage = observer(() => {
    return (
        <Flex>
            <div className={style.logoBackgroundBase}>
                <img src={FlLogo}></img>
            </div>
            <div
                style={{ transform: 'translate(-10px, -10px)' }}
                className={style.filterBlue}
            >
                <LoadingAnimation width={70} height={70} />
            </div>
        </Flex>
    );
});

export default WaitingMessage;
